import { useEffect, useState } from "react";
import { clientCMSRH } from "../../sanity/clientCMSRH.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import { TbBriefcase2 } from "react-icons/tb";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaRegClock } from "react-icons/fa";
import { LuHandshake } from "react-icons/lu";
import { MdOutlineSearchOff } from "react-icons/md";
import "./JobCards.css";

export default function JobCards(props) {
  const [allJobCardsData, setAllJobCardsData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMSRH
      .fetch(
        `*[_type == "position"]{
        title,
        slug,
        "sector": sector->title,
        "location": location->title,
        "workload": workload->title,
        "modality": modality->title,
        link,
        publishedAt,
    }`
      )
      .then((data) => {
        setAllJobCardsData(data);
        if (data.length === 0)
          setDataContainer(
            <div className="no-data-container">
              <MdOutlineSearchOff className="no-data-container-icon" /> Sem
              vagas abertas no momento
            </div>
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!allJobCardsData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  return (
    <Container>
      <Row>
        {allJobCardsData && allJobCardsData.length > 0
          ? allJobCardsData &&
            allJobCardsData.map((position, index) => (
              <Col key={index} className="job-cards-col">
                <div
                  style={{
                    backgroundColor: props.white,
                    boxShadow: props.shadowColor,
                  }}
                  className="job-card"
                >
                  <div className="job-card-overlay">
                    <a
                      href={position.link}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="job-card-link"
                    >
                      {position.title ? (
                        <h3 style={{ color: props.titleColor }}>
                          {position.title.toUpperCase()}
                        </h3>
                      ) : (
                        ""
                      )}
                      <div className="job-card-info">
                        {position.sector ? (
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <TbBriefcase2 style={{ color: props.iconColor }} />{" "}
                            {position.sector}
                          </p>
                        ) : (
                          ""
                        )}
                        {position.location ? (
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <HiOutlineLocationMarker
                              style={{ color: props.iconColor }}
                            />{" "}
                            {position.location}
                          </p>
                        ) : (
                          ""
                        )}
                        {position.workload ? (
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <FaRegClock style={{ color: props.iconColor }} />{" "}
                            {position.workload}
                          </p>
                        ) : (
                          ""
                        )}
                        {position.modality ? (
                          <p
                            style={{
                              color: props.textColor,
                              fontSize: props.subTextSize,
                            }}
                          >
                            <LuHandshake style={{ color: props.iconColor }} />{" "}
                            {position.modality}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="job-card-btn-container">
                        <div
                          style={{
                            color: props.white,
                            backgroundColor: props.btnColor,
                          }}
                          className="job-card-btn"
                        >
                          VER VAGA
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </Col>
            ))
          : dataContainer}
      </Row>
    </Container>
  );
}
